/**
 * Asynchronously loads the component for Portfolios
 */

import { lazyLoad } from 'utils/loadable';

export const PortfoliosPage = lazyLoad(
  () => import('./index'),
  module => module.Portfolios,
);
